import { EdgeLoadParticipantComplianceRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadParticipantCompliance } from '@/shared/domain/use-cases'

export function makeLoadParticipantCompliance(): LoadParticipantCompliance {
  return new EdgeLoadParticipantComplianceRepository(makeSupabaseEdgeHttpClient()).execute
}
